'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SnowplowTracker = exports.trackUnstruct = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _universalConfig = require('universal-config');

var _universalConfig2 = _interopRequireDefault(_universalConfig);

var _localStorage = require('redux/saga/helpers/local-storage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var spScriptRendered = false;
var SNOWPLOW_ENABLED = __CLIENT__ || __TEST__;

var SP_INIT_JS = '(function(p,l,o,w,i,n,g){if(!p[i]||!p[i].track){p.GlobalSnowplowNamespace=p.GlobalSnowplowNamespace||[];\n  p.GlobalSnowplowNamespace.push(i);if(!p[i]){p[i]=function(){(p[i].q=p[i].q||[]).push(arguments)}};\n  p[i].q=p[i].q||[];n=l.createElement(o);g=l.getElementsByTagName(o)[0];n.async=1;n.src=w;\n  g.parentNode.insertBefore(n,g)}}(window,document,"script","//d1fc8wv8zag5ca.cloudfront.net/2.6.1/sp.js","snowplow"));';

var TRACKER = (0, _universalConfig2.default)().snowplow.tracker;

var trackUnstruct = exports.trackUnstruct = function trackUnstruct(name) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (SNOWPLOW_ENABLED) {
    if (__CLIENT__ && (0, _localStorage.readLocalStorage)('trackingDebug')) {
      console.info('Tracking snowplow', name, data); // eslint-disable-line no-console
    }

    if (!window.snowplow) {
      window.snowplow = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return (window.snowplow.q = window.snowplow.q || []).push(args);
      };
    }

    window.snowplow('trackUnstructEvent:' + TRACKER, {
      schema: 'iglu:com.classpass/general_event/jsonschema/1-0-0',
      data: {
        event_type: name,
        event_data: (0, _stringify2.default)(data || {})
      }
    });
  }
};

var SnowplowTracker = exports.SnowplowTracker = function (_React$Component) {
  (0, _inherits3.default)(SnowplowTracker, _React$Component);

  function SnowplowTracker() {
    (0, _classCallCheck3.default)(this, SnowplowTracker);
    return (0, _possibleConstructorReturn3.default)(this, (SnowplowTracker.__proto__ || (0, _getPrototypeOf2.default)(SnowplowTracker)).apply(this, arguments));
  }

  (0, _createClass3.default)(SnowplowTracker, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          host = _props.host,
          appId = _props.appId;


      if (spScriptRendered && !__TEST__) {
        return;
      }
      spScriptRendered = true;

      var sdkInitJs = 'snowplow(\'newTracker\', \'' + TRACKER + '\', \'' + host + '\', {\n      appId: \'' + appId + '\',\n      platform: \'web\',\n      bufferSize: 1,\n      encodeBase64: true,\n      forceSecureTracker: true,\n      post: false\n    });';

      var script = document.createElement('script');
      script.textContent = SP_INIT_JS + sdkInitJs;
      script.id = 'sp-js-root';
      document.body.appendChild(script);
    }
  }, {
    key: 'render',
    value: function render() {
      return false;
    }
  }]);
  return SnowplowTracker;
}(_react2.default.Component);

SnowplowTracker.propTypes = {
  host: _propTypes2.default.string.isRequired,
  appId: _propTypes2.default.string.isRequired
};